import { Injectable } from '@angular/core';

@Injectable()
export class TabletUtil {
  dblclickTracker = { ref: '', time: 0 };

  handleDblclick(ref: string, func: () => void): void {
    if (this.dblclickTracker.ref !== ref) {
      this.dblclickTracker = { ref, time: new Date().getTime() };
    } else if (!this.dblclickTracker.time) {
      this.dblclickTracker.time = new Date().getTime();
    } else if (new Date().getTime() - this.dblclickTracker.time < 400) {
      func();
      this.dblclickTracker = { ref: '', time: 0 };
    } else {
      this.dblclickTracker.time = new Date().getTime();
    }
  }
}
